'use client';
import BaseChart from '@/components/BaseChart';
import { bmiConfig } from '@/utils/chart_configs';
import { getChartDataSets, getChartDataSetByGenderAndAge } from '@/utils/chart_service';
import { getYAxisDataPointsForBMIChartByUnit } from '@/utils/data_points_service';
import { calculateAgeInMonthsWithTwoDates } from '@/utils/lm_utilities';
import _ceil from 'lodash/ceil';
import _round from 'lodash/round';
import _floor from 'lodash/floor';
import _first from 'lodash/first';
import { calculatePercentileWithZscores, getAxisPoints, getBlurbData } from '@/utils/charts_utils';
import { useState } from 'react';

const BMIChart = ({ params, metaInfo, ...props }) => {
  const [blurbData, setBlurbData] = useState({
    ...getBlurbData(),
  });
  metaInfo.defaultMeasurementValue = metaInfo.chartData;

  const _getAxisPoints = (unit, calculated_age) => {
    const options = getYAxisDataPointsForBMIChartByUnit(unit, calculated_age);
    return getAxisPoints(options, calculated_age);
  };

  const getDataPoints = async (gender, calculated_age, unit) => {
    let temp_age = calculated_age;
    if (Number(calculated_age) > 240) {
      const remainder = calculated_age % 12;
      temp_age -= remainder;
    }
    const response = await getChartDataSets('BmiChart', gender, temp_age, unit);
    return response.json();
  };

  const calculatePercentile = async (bmi, formData, isNewChart) => {
    try {
      let calculated_age = calculateAgeInMonthsWithTwoDates(formData.dob, formData.md);

      if (calculated_age < 24) {
        return false;
      }

      let percentile = 0;
      if (calculated_age < 24) {
        console.log('BMI Charts are not supported for ages <= 24 Months');
      } else if (calculated_age >= 24 && calculated_age <= 240) {
        let floor = _floor(calculated_age) + 0.5;
        let ceil = _ceil(calculated_age) + 0.5;
        if (floor === ceil) {
          if (floor > 0) {
            floor = floor + 1;
          }
        }

        if (floor === ceil && floor === 0 && ceil === 0) {
          floor = 0;
          ceil = floor + 1;
        }
        if (!isNewChart) {
          setBlurbData(getBlurbData(formData.unit, _first(metaInfo?.getChartDataSetByGenderAndAgeRes.charts)));
          percentile = calculatePercentileWithZscores(
            metaInfo?.getChartDataSetByGenderAndAgeRes,
            metaInfo?.getChartDataSetByGenderAndAgeCeilRes,
            calculated_age,
            floor,
            ceil,
            bmi,
          );
        } else {
          const floorData = await getChartDataSetByGenderAndAge('BmiChart', formData.gender, floor);
          const floorJson = await floorData.json();
          setBlurbData(getBlurbData(formData.unit, _first(floorJson.charts)));

          const ceilData = await getChartDataSetByGenderAndAge('BmiChart', formData.gender, ceil);
          const ceilJson = await ceilData.json();

          percentile = calculatePercentileWithZscores(floorJson, ceilJson, calculated_age, floor, ceil, bmi);
        }
      } else if (calculated_age > 240) {
        const remainder = calculated_age % 12;
        if (remainder > 0) {
          calculated_age -= remainder;
        }
        let floor = calculated_age - 12;
        let ceil = calculated_age;

        if (floor === ceil) {
          floor = floor - 12;
        }
        const floorData = await getChartDataSetByGenderAndAge('BmiChart', formData.gender, floor);
        const floorJson = await floorData.json();
        setBlurbData(getBlurbData(formData.unit, _first(floorJson.charts)));

        const ceilData = await getChartDataSetByGenderAndAge('BmiChart', formData.gender, ceil);
        const ceilJson = await ceilData.json();

        percentile = calculatePercentileWithZscores(floorJson, ceilJson, calculated_age, floor, ceil, bmi);
      }

      return {
        percentile: _round(percentile, 2),
        value: bmi,
      };
    } catch (err) {
      console.error('Error calculating BMI percentile:', err);
      return null;
    }
  };

  return (
    <BaseChart
      params={params}
      metaInfo={metaInfo}
      {...bmiConfig}
      getDataPoints={getDataPoints}
      getAxisPoints={_getAxisPoints}
      calculatePercentile={calculatePercentile}
      handleMeasurement={bmiConfig.handleMeasurement}
      blurbData={blurbData}
    >
      {props.children}
    </BaseChart>
  );
};

// const BMIChart = ({ params, metaInfo, ...props }) => {
//   const [blurbData, setBlurbData] = useState({
//     ...getBlurbData(),
//   });
//   metaInfo.defaultMeasurementValue = metaInfo.chartData;

//   const _getAxisPoints = (unit, calculated_age) => {
//     const options = getYAxisDataPointsForBMIChartByUnit(unit, calculated_age);
//     return getAxisPoints(options, calculated_age);
//   };

//   const getDataPoints = async (gender, calculated_age, unit) => {
//     const response = await getChartDataSets('BmiChart', gender, calculated_age, unit);
//     return response.json();
//   };

//   const calculatePercentile = async (bmi, formData, isNewChart) => {
//     try {
//       const calculated_age = calculateAgeInMonthsWithTwoDates(formData.dob, formData.md);

//       if (calculated_age < 2 || calculated_age > 240) {
//         return false;
//       }

//       let percentile = 0;
//       if (calculated_age < 24) {
//         console.log('BMI Charts are not supported for ages <= 24 Months');
//       } else {
//         let floor = _floor(calculated_age) + 0.5;
//         let ceil = _ceil(calculated_age) + 0.5;

//         if (floor === ceil) {
//           if (floor > 0) floor = floor + 1;
//         }

//         if (floor === ceil && floor === 0 && ceil === 0) {
//           floor = 0;
//           ceil = floor + 1;
//         }

//         if (!isNewChart) {
//           setBlurbData(getBlurbData(formData.unit, _first(metaInfo?.getChartDataSetByGenderAndAgeRes.charts)));
//           percentile = calculatePercentileWithZscores(
//             metaInfo?.getChartDataSetByGenderAndAgeRes,
//             metaInfo?.getChartDataSetByGenderAndAgeCeilRes,
//             calculated_age,
//             floor,
//             ceil,
//             bmi,
//           );
//         } else {
//
//           const [floorJson, ceilJson] = await Promise.all([
//             getChartDataSetByGenderAndAge('BmiChart', formData.gender, floor).then((res) => res.json()),
//             getChartDataSetByGenderAndAge('BmiChart', formData.gender, ceil).then((res) => res.json()),
//           ]);

//           setBlurbData(getBlurbData(formData.unit, _first(floorJson.charts)));

//           percentile = calculatePercentileWithZscores(floorJson, ceilJson, calculated_age, floor, ceil, bmi);
//         }
//       }

//       return {
//         percentile: _round(percentile, 2),
//         value: bmi,
//       };
//     } catch (err) {
//       console.error('Error calculating BMI percentile:', err);
//       return null;
//     }
//   };

//   return (
//     <BaseChart
//       params={params}
//       metaInfo={metaInfo}
//       {...bmiConfig}
//       getDataPoints={getDataPoints}
//       getAxisPoints={_getAxisPoints}
//       calculatePercentile={calculatePercentile}
//       handleMeasurement={bmiConfig.handleMeasurement}
//       blurbData={blurbData}
//     >
//       {props.children}
//     </BaseChart>
//   );
// };

export default BMIChart;
